import { Attendances } from '@/@data'
import { AttendanceTable } from '@/components/attendance/tables/AttendanceTable'
import { BoxPage } from '@/components/common/BoxPage'
import { useRouteQuery, useTranslator } from '@/hooks'
import { Card, CardContent } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

const Attendance = () => {
  const { __ } = useTranslator()
  const { searchQuery } = useRouteQuery()

  const params = useMemo(() => {
    return {
      page: searchQuery.get('page'),
      perPage: searchQuery.get('perPage'),
      month: searchQuery.get('month'),
      company_id: searchQuery.get('company_id')
    }
  }, [searchQuery])

  const { data, refetch } = useQuery({
    ...Attendances.getAttendance(params)
  })

  return (
    <BoxPage title={__('Attendance Management')} breadcrumbs={[{ label: __('Attendance Management') }]}>
      <Card sx={{ borderRadius: 3 }}>
        <CardContent sx={{ padding: 0 }}>
          <AttendanceTable
            data={data?.data || []}
            onSuccess={refetch}
            meta={data?.meta}
          />
        </CardContent>
      </Card>
    </BoxPage>
  )
}

export default Attendance
